import React from 'react'
import './Logo.css'

export default () => (
  <div className="logo">
  	<span className="logo_main">Perry Leijten</span>
	<span className="logo_aside">Technical Artist</span>   				
  </div>
)
